import React, { Component } from 'react';

import { Helmet } from 'react-helmet'

import Header from './block/Header';
import Footer from './block/Footer';
import OffcanvasMenu from './block/OffcanvasMenu';
import Window from './block/Window';
import CookieBanner from './block/CookieBanner';
import MobileFooter from './block/MobileFooter';
import KvizWin from './block/KvizWin';

// import FloatingLanguageSwitcher from './components/FloatingLanguageSwitcher';
// import GoogleTranslateProvider from './components/GoogleTranslateProvider';

import Main from './pages/MainPage';
import Katalog from './pages/Katalog';
import About from './pages/About';
import PriceList from './pages/PriceList';
import Gos from './pages/Gos';
import ProductionCapacity from './pages/ProductionCapacity';
import Partners from './pages/Partners';
import OurNeeds from './pages/OurNeeds';
import Reviews from './pages/Reviews';
import Staff from './pages/Staff';
import Objects from './pages/Objects';
import News from './pages/News';
import TechnicalLiterature from './pages/TechnicalLiterature';
import Documentation from './pages/Documentation';
import Delivery from './pages/Delivery';
import Packaging from './pages/Packaging';
import Events from './pages/Events';
import Coolant from './pages/Coolant';
import SellingPoints from './pages/SellingPoints';
import Razdel from './pages/Razdel';
import Product from './pages/Product';
import Kontakti from './pages/Kontakti';
import DeIcingLiquid from './pages/DeIcingLiquid';
import TextPage from './pages/TextPage';
import SearchResult from './pages/SearchResult';
import Uslugi from './pages/Uslugi';
import Export from './pages/Export';
import Kviz from './pages/Kviz';
import Invest from './pages/Invest';

class App extends Component {
  state = {
    showOffcanvas: false,
    showWindow: false,
    showKviz: false
  };

  componentDidMount() {
    this.loadYandexMetrikaOnInteraction();
  }

  loadYandexMetrikaOnInteraction() {
    const ymId = this.props?.data?.helmet?.host == 'nn.himavangard.ru' ? '110452454' : '14982298';

    const loadMetrika = () => {
      document.removeEventListener('mousemove', loadMetrika);
      document.removeEventListener('touchstart', loadMetrika);

      // Загружаем Яндекс.Метрику только если её ещё нет
      if (window.ym) return;

      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(ymId, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true,
        ecommerce:"dataLayer"
      });
    };

    document.addEventListener('mousemove', loadMetrika, { once: true });
    document.addEventListener('touchstart', loadMetrika, { once: true });
  }

  handleShow = () => {
    this.setState({ showOffcanvas: true });
  };

  handleHide = () => {
    this.setState({ showOffcanvas: false });
  };

  handleShowWindow = () => {
    this.setState({ showWindow: true });
  };

  handleHideWindow = () => {
    this.setState({ showWindow: false });
  };

  handleShowKviz = () => {
    this.setState({ showKviz: true });
  }

  handleHideKviz = () => {
    this.setState({ showKviz: false });
  }

  renderPage(tpl) {
    const { data } = this.props;

    switch(tpl) {
      case 1:
        return <Main data={data} showWindow={this.handleShowWindow} />;
      case 2:
        return <Katalog data={data} showWindow={this.handleShowWindow} />;
      case 3:
        return <Razdel data={data} showWindow={this.handleShowWindow} />;
      case 6:
        return <About data={data} showWindow={this.handleShowWindow} />;
      case 8:
        return <PriceList data={data} showWindow={this.handleShowWindow} />;
      case 9:
        return <Gos data={data} showWindow={this.handleShowWindow} />;
      case 10:
        return <ProductionCapacity data={data} showWindow={this.handleShowWindow} />;
      case 11:
        return <Partners data={data} showWindow={this.handleShowWindow} />;
      case 12:
        return <OurNeeds data={data} showWindow={this.handleShowWindow} />;
      case 13:
        return <Reviews data={data} showWindow={this.handleShowWindow} />;
      case 14:
        return <Staff data={data} showWindow={this.handleShowWindow} />;
      case 15:
        return <Objects data={data} showWindow={this.handleShowWindow} />;
      case 4:
        return <News data={data} showWindow={this.handleShowWindow} />;
      case 16:
        return <TechnicalLiterature data={data} showWindow={this.handleShowWindow} />;
      case 17:
        return <Documentation data={data} showWindow={this.handleShowWindow} />;
      case 18:
        return <Delivery data={data} showWindow={this.handleShowWindow} />;
      case 19:
        return <Packaging data={data} showWindow={this.handleShowWindow} />;
      case 20:
        return <Events data={data} showWindow={this.handleShowWindow} />;
      case 21:
        return <Coolant data={data} showWindow={this.handleShowWindow} />;
      case 22:
        return <SellingPoints data={data} showWindow={this.handleShowWindow} />;
      case 23:
        return <Product data={data} showWindow={this.handleShowWindow} />;
      case 24:
        return <Kontakti data={data} showWindow={this.handleShowWindow} />;
      case 25:
        return <DeIcingLiquid data={data} showWindow={this.handleShowWindow} />;
      case 27:
        return <SearchResult data={data} showWindow={this.handleShowWindow} />;
      case 28:
        return <Uslugi data={data} showWindow={this.handleShowWindow} />;
      case 29:
        return <Export data={data} showWindow={this.handleShowWindow} />;
      case 30:
        return <Kviz data={data} showWindow={this.handleShowWindow} />;
      case 31:
        return <Invest data={data} showWindow={this.handleShowWindow} />;
      default:
        return <TextPage data={data} />;
    }
  }

  // Новый метод для генерации JSON-LD хлебных крошек
  generateBreadcrumbJsonLd() {
    const { data } = this.props;
    const breadcrumbs = data?.breadcrumbs;

    // Проверяем, есть ли данные и это массив
    if (!breadcrumbs || !Array.isArray(breadcrumbs) || breadcrumbs.length === 0) {
      return null;
    }

    // Преобразуем формат из data.breadcrumbs в формат Schema.org
    const itemListElement = breadcrumbs.map((item, index) => {
      // Ваш формат: item.item.name и item.item["@id"]
      // Нужно убедиться, что поля существуют
      const name = item?.item?.name;
      const itemUrl = item?.item?.["@id"];

      // Возвращаем только если есть имя
      if (!name) return null;

      return {
        "@type": "ListItem",
        "position": item.position || index + 1, // используем позицию из данных или индекс
        "name": name,
        // Добавляем item только если есть URL
        ...(itemUrl && { "item": itemUrl })
      };
    }).filter(item => item !== null); // Убираем null элементы

    if (itemListElement.length === 0) {
      return null;
    }

    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": itemListElement
    };
  }

  render() {
    // Нормализуем данные: helmet может отсутствовать (direct GET без данных,
    // боты/health-check) — иначе SSR падал на data.helmet.* и отдавал 503.
    const propsData = this.props?.data || {};
    const data = { ...propsData, helmet: propsData.helmet || {} };
    const breadcrumbJsonLd = this.generateBreadcrumbJsonLd(); // генерируем данные

    const host = data?.helmet.host || 'himavangard.ru';
    const isNN = host === 'nn.himavangard.ru';
    const regionIn = isNN ? 'в Нижнем Новгороде и Дзержинске' : 'в Москве';

    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "WholesaleStore",
      "name": isNN ? 'ПКФ ХимАвангард — производство промышленной химии' : 'ПКФ ХимАвангард',
      "image": `https://${host}/logo.png`,
      "id": `https://${host}/#organization`,
      "url": `https://${host}/`,
      "telephone": "+78005006081",
      "email": "info@himavangard.ru",
      "address": isNN ? {
        "@type": "PostalAddress",
        "streetAddress": "Нижегородское шоссе, 6",
        "addressLocality": "Дзержинск",
        "addressRegion": "Нижегородская область",
        "addressCountry": "RU"
      } : {
        "@type": "PostalAddress",
        "streetAddress": "Складочная ул., д. 1, стр. 1, БП Станколит",
        "addressLocality": "Москва",
        "postalCode": "127018",
        "addressCountry": "RU"
      },
      "geo": isNN ? {
        "@type": "GeoCoordinates",
        "latitude": 56.2383,
        "longitude": 43.4631
      } : {
        "@type": "GeoCoordinates",
        "latitude": 55.8006,
        "longitude": 37.5956
      },
      "areaServed": isNN ? [
        { "@type": "City", "name": "Нижний Новгород" },
        { "@type": "City", "name": "Дзержинск" },
        { "@type": "AdministrativeArea", "name": "Нижегородская область" }
      ] : [
        { "@type": "City", "name": "Москва" },
        { "@type": "AdministrativeArea", "name": "Московская область" },
        { "@type": "Country", "name": "Россия" }
      ],
      "description": isNN
        ? "Производство и оптовые поставки химической продукции, теплоносителей и антифризов от 1 тонны. Собственное производство в Дзержинске, отгрузка по Нижнему Новгороду и Нижегородской области."
        : "Производство и оптовые поставки химической продукции, теплоносителей и антифризов от 1 тонны в Москве и по всей России.",
      "priceRange": "$$"
    }

    return (
      <>
        <Helmet>
          {data?.helmet.longtitle != '' ?
            <title>{data?.helmet.longtitle || 'Химавангард'}</title>
          :
            <title>{( data?.helmet.title || 'Химавангард' ) + ` | Продажа химической продукции ${regionIn}`}</title>
          }

          <link rel="preconnect" href={`https://${data?.helmet.host || 'himavangard.ru'}`} />
          <link rel="dns-prefetch" href={`https://${data?.helmet.host || 'himavangard.ru'}`} />

          <meta name="robots" content="all" />

          <meta name="keywords" content={data?.helmet.keywords || 'химическое сырье, химическое сырье купить, химическое сырье оптом, продажа химической продукции'} />
          <meta name="description" content={data?.helmet.description || 'Химавангард'} />

          <meta property="og:type" content="website" />
          <meta property="og:title" content={data?.helmet.longtitle != '' ? (data?.helmet.longtitle || 'Химавангард') : ( data?.helmet.title || 'Химавангард' ) + ` | Продажа химической продукции ${regionIn}`} />
          <meta property="og:description" content={data?.helmet.description || 'Химавангард'} />
          <meta property="og:image" content={`https://${data?.helmet.host || 'himavangard.ru'}/assets/cache_image/logo_0x0_6f7.webp`} />
          <meta property="og:url" content={`https://${data?.helmet.host || 'himavangard.ru'}${data?.url || '/'}`} />

          <link rel="canonical" href={`https://${data?.helmet.host || 'himavangard.ru'}${data?.url || '/'}`} />

          {data?.helmet.host == 'nn.himavangard.ru' ? <meta name="yandex-verification" content="3693716e84dd12a0" /> : <meta name="yandex-verification" content="7941611da323b16b" />}

          <link rel="icon" href="/favicon.svg" type="image/x-icon" />

          <link rel="preconnect" href="https://himavangard.ru/assets/fonts/Involve/Involve.css" />

          {/* Вставляем JSON-LD скрипт */}
          {breadcrumbJsonLd && (
            <script type="application/ld+json">
              {JSON.stringify(breadcrumbJsonLd)}
            </script>
          )}
          <script type="application/ld+json">
            {JSON.stringify(jsonLd)}
          </script>
          {data?.template === 23 && data?.product &&
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Product",
                "name": data?.pagetitle,
                "description": data?.helmet.description || data?.introtext || data?.pagetitle,
                ...(data?.product?.image ? { "image": `https://${host}${data.product.image}` } : {}),
                "url": `https://${host}${data?.url || ''}`,
                "category": data?.product?.parent_title || 'Промышленная химия',
                "brand": { "@type": "Brand", "name": "ХимАвангард" },
                "manufacturer": { "@type": "Organization", "name": "ПКФ ХимАвангард", "url": `https://${host}/` }
              })}
            </script>
          }
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org/",
              "@type": "WebPage",
              "name": "Производитель химической продукции оптом. Выпускаем технологические, охлаждающие, противообледенительные жидкости, дезинфицирующие средства и бытовую химию для промышленных задач. Отгружаем от 1 тонны по всей России.",
              "speakable": {
                "@type": "SpeakableSpecification",
                "xpath": [
                  "/html/head/title",
                  "/html/head/meta[@name='description']/@content"
                ]
              },
              "url": `https://${data?.helmet.host || 'himavangard.ru'}`
            })}
          </script>
        </Helmet>


        {/* Google Ads conversion tracking */}
        <script data-skip-moving="true">
          {`
            function gtag_report_conversion(url) {
              var callback = function () {
                if (typeof(url) != 'undefined') {
                  window.location = url;
                }
              };
              gtag('event', 'conversion', {
                'send_to': 'AW-856660877/cMATCN7prZcBEI23vpgD',
                'event_callback': callback
              });
              return false;
            }
          `}
        </script>

        <div className="min-h-svh flex flex-col items-start justify-between w-full overflow-x-hidden">
          <div className='flex-1 w-full'>
            <Header showMenu={this.handleShow} showWindow={this.handleShowWindow} data={data} />
            {this.renderPage(data?.template)}
          </div>
          <div className='w-full'>
            <Footer data={data} showWindow={this.handleShowWindow} />
          </div>
        </div>
        <OffcanvasMenu
          show={this.state.showOffcanvas}
          hide={this.handleHide}
          data={data}
          placement="start"
          backdrop={true}
        />
        <MobileFooter data={data} showKviz={this.handleShowKviz} />
        <Window
          show={this.state.showWindow}
          onHide={this.handleHideWindow}
          data={data}
        />
        <KvizWin
          show={this.state.showKviz}
          showFn={this.handleShowKviz}
          hideFn={this.handleHideKviz}
          data={data}
        />
        <CookieBanner />
      </>
    );
  }
}

export default App;
